import { useState, useEffect } from 'react';
import * as DisplayControl from '../utils/displayControl';

/**
 * Full-screen black overlay shown when display is "dimmed off"
 * Tap anywhere to dismiss and restore brightness
 */
function ScreenDimOverlay() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check initial state
    const initialState = DisplayControl.getDisplayState();
    setIsVisible(initialState === 'off');

    // Subscribe to display state changes (event-based, not polling)
    const unsubscribe = DisplayControl.subscribeToDisplayState((state) => {
      setIsVisible(state === 'off');
    });

    return () => unsubscribe();
  }, []);

  const handleTap = async () => {
    // Restore display on tap
    await DisplayControl.turnDisplayOn();
    // State will be updated via subscription
  };

  if (!isVisible) return null;

  return (
    <div
      onClick={handleTap}
      className="fixed top-0 left-0 right-0 bottom-0 bg-black z-[99999] cursor-pointer"
      style={{ touchAction: 'manipulation' }}
    />
  );
}

export default ScreenDimOverlay;
